import { Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import Offense from '../../models/offense';
import OffenseService from '../../services/offenseService';
import OffenseRecord from '../../models/offenseRecord';
import { ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import isDateValidator from '../../validators/isDateValidator';
import { OffenseCodes } from '../../models/offenseCodes';
import FormControl from '../../models/formControl';
import * as alertify from 'alertifyjs';
import HttpError from '../../models/httpError';
import BrowserWindowObjectService from '../../services/browserWindowObjectService';
import ComplianceAuditLogService from '../../services/complianceAuditLogService';
import { ConfirmResult } from '../../models/alertifyPromise';
import PopupHelper from '../../models/popupHelper';
import ComplianceAuditLog from '../../models/complianceAuditLog';
import Charge from 'models/charge';
import { MessageQueService } from '../../services/index';

@Component({
  selector: 'app-offense',
  templateUrl: './offense.component.html',
  styleUrls: [
    './offense.component.scss',
  ],
  providers: [OffenseService, MessageQueService]
})

export default class OffenseComponent implements OnInit {
  constructor(private offenseService: OffenseService,
    private browserWindowObjectService: BrowserWindowObjectService,
    private complianceAuditLogService: ComplianceAuditLogService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private msgSvc: MessageQueService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.route.params.subscribe((params: any) => {
      this.requestNumber = params['requestNumber'] as number;
    });
  }

  ngOnInit() {
    this.msgSvc.setControlKey(); // ('CacheControlKey');
    this.browserWindowObjectService.scrollToTopOfPage();

    this.offenseService.getOffense(this.requestNumber)
    .subscribe((object: any) => {
      if (object instanceof Offense) {
        this.offense = object as Offense;
        this.checkWorkOrderComplete();
      } else {
        const httpError = object as HttpError;
        if (httpError.status === 422) {
          this.browserWindowObjectService.goBackOnePage();
          // alertify.alert('Crim Error', 'You did not send a valid request');
        }
      }
    });

    this.offensePageForm = this.formBuilder.group({
      offenseSearch: this.formBuilder.group({
        admittedCrimeNotFound: ['']
      }),
      offenseRecord: this.formBuilder.group({
        sentenceLevel: [''],
        // This is just to do have a validator for identifers.
        hasIdentifier: [''],
        hasNameIdentifier: [''],
        hasDobIdentifier: [''],
        hasSsnIdentifier: [''],
        hasSinIdentifier: [''],
        hasAddressIdentifier: [''],
        hasDlnIdentifier: [''],
        isRecordLevel: [''],
        hasFaxInformation: [''],
        courtRecordedFullName: ['', [
            Validators.required,
            Validators.maxLength(60),
          ]
        ],
        nameDiffers: [''],
        referenceNumber: ['', [
            Validators.required,
            Validators.maxLength(25),
          ]
        ],
        courtRecordDob: ['', isDateValidator(1900)],
        dobType: [''],
        month: [''],
        day: [''],
        year: [''],
        // fullDobValidator and partialDobValidator
        // are placeholders for the validators.
        fullDobValidator: [''],
        partialDobValidator: [''],
        offenseDate: ['', isDateValidator(2000)],
        fileDate: ['', isDateValidator(2000)],
        arrestDate: ['', isDateValidator(2000)],
        dispositionDate: ['', isDateValidator(2000)],
        // This is just to do have a validator to make sure you
        // all dates are good.
        hasRequiredDate: [''],
        offenseDateGreaterThanCurrentDate: [''],
        fileDateGreaterThanCurrentDate: [''],
        arrestDateGreaterThanCurrentDate: [''],
        dispositionDateGreaterThanCurrentDate: [''],
        fileDateDateOlderThanOffenseDate: [''],
        dispositionDateOlderThanOffenseDate: [''],
        dispositionDateOlderThanFileDate: [''],
        offenseDateAtRecordAndChargeLevel: [''],
        fileDateAtRecordAndChargeLevel: [''],
        arrestDateAtRecordAndChargeLevel: [''],
        dispositionDateAtRecordAndChargeLevel: [''],
        probation: ['', Validators.maxLength(255) ],
        fines: ['', Validators.maxLength(255) ],
        courtCosts: ['', Validators.maxLength(255) ],
        jailTime: ['', Validators.maxLength(255) ],
        prisonTime: ['', Validators.maxLength(255) ],
        suspensionTime: ['', Validators.maxLength(255) ],
        nextCourtDate: ['', isDateValidator(2000)],
        comments: ['', Validators.maxLength(3000) ],
        otherSentenceNotes: ['', Validators.maxLength(5000) ],
        charge: this.formBuilder.group({
          hasChargesValidator: ['']
        })
      })
    });

    this.formControl = new FormControl(this.offensePageForm);
  }

  updateToCurrentOffenseRecord(offenseRecord: OffenseRecord) {
    this.currentOffenseRecord = offenseRecord;
    this.isNewRecord = this.currentOffenseRecord.isNewRecord;
    this.validateHasCharges();
    this.validateHasChargeDates();
  }

  updateCanDeleteCurrentOffenseRecord(canDelete: boolean) {
    this.canDelete = canDelete;
  }

  updateToCurrentOffenseCharges() {
    this.validateHasCharges();
    this.validateHasChargeDates();
  }

  async onSubmit() {
    const dobInformation = this.getDobInformation();
    let save = true;

    try {
      if (this.hasDobMismatch(dobInformation)) {
        const complianceAuditLogs = new Array<ComplianceAuditLog>();
        complianceAuditLogs.push(new ComplianceAuditLog(this.requestNumber, 'DOBMISMATCH', 'OFFENCEPG', null, null));

        if (await PopupHelper.dobMismatchHelper() === ConfirmResult.Cancel) {
          complianceAuditLogs.push(new ComplianceAuditLog(this.requestNumber, 'DOBMISMATCH_UPDATE', 'OFFENCEPG', null, null));
          save = false;

          // This is a hack.
          // For whatever reason if the time between
          // await PopupHelper.dobMismatchHelper() === ConfirmResult.Cancel
          // and
          // await this.complianceAuditLogService.addComplianceAuditLogs(complianceAuditLogs);
          // is under about 290ms, it will set focus to text box and then scroll to the bottom
          // of page and unset focus.
          // So telling the system to wait about 320ms before setting focus.
          setTimeout(() => this.offenseRecordComponent.setFocusForDobMismatch(), 320);

        } else {
          complianceAuditLogs.push(new ComplianceAuditLog(this.requestNumber, 'DOBMISMATCH_PROCEED', 'OFFENCEPG', null, null));
        }

        await this.complianceAuditLogService.addComplianceAuditLogs(complianceAuditLogs);
      }

      if (save) {
        this.isSaving = true;
        const offense = this.createOffenseObject(dobInformation);
        this.offenseService.save(offense).subscribe((r: any) => {
          if (r instanceof HttpError) {
            if (r.status === 422) {
              const errorCodes = r.httpResponse.json().errorCodes as OffenseCodes[];
              const message = `An error occurred while trying to save request with error code(s) ${errorCodes.join()}.
                <br>Get more information
                <a href='https://github.geninfo.com/BackOfficeCrim/CRIM-System/wiki/Offense-API-Validation'>here</a>`;
                alertify.alert('Crim Error', message);
            }
          } else {
            this.isNewRecord = this.currentOffenseRecord.isNewRecord = false;
            this.offenseRecordComponent.saveCompletedSuccessfully();
            this.offensePageForm.markAsPristine();
            this.browserWindowObjectService.scrollToTopOfPage();
            this.checkWorkOrderComplete();
          }
          this.isSaving = false;
        });
      }
    } catch (e) {
      this.isSaving = false;
      // An exception will happen with a DOB mismatch and when sending a
      // request to ComplianceAuditLog api and the api returns anything other than a HTTP 200.
      // In that case we don't want to save the request.
    }
  }

  async deleteRecord() {
    const confirmResult = await PopupHelper.deleteRecordHelper();

    if (confirmResult === ConfirmResult.Ok) {
      this.offenseService.delete(this.requestNumber, this.currentOffenseRecord.offenseNumber)
      .subscribe((error: HttpError) => {
        if (error === null) {
          const index = this.offense.offenseRecords.indexOf(this.currentOffenseRecord);
          this.offense.offenseRecords.splice(index, 1);
          this.checkWorkOrderComplete();
          this.offenseRecordComponent.deleteSuccessfully();
        }
      });
    }
  }

  goToNavigation() {
    this.router.navigate(['navigation']);
  }

  async exitDialog() {
    const confirmResult = await PopupHelper.exitSystemHelper();

    if (confirmResult === ConfirmResult.Ok) {
      this.router.navigate(['exit']);
    }
  }

  about() {
    PopupHelper.systemVersion();
  }

  support() {
    PopupHelper.support();
  }

  help() {
    this.browserWindowObjectService.openWindowInNewWindowByRoute(`offenseHelp`, '', 800, 900);
  }

  get hasChargesValidator() { return this.offensePageForm.get('offenseRecord.charge.hasChargesValidator'); }
  get hasRequiredDate() { return this.offensePageForm.get('offenseRecord.hasRequiredDate'); }

  private validateHasCharges() {
    if (!this.hasCharges) {
      this.formControl.setValidationErrorByControlName('offenseRecord.charge.hasChargesValidator', 'hasCharges');
    } else {
      this.formControl.clearValidatorErrorByControlName('offenseRecord.charge.hasChargesValidator', 'hasCharges');
    }
  }

  private validateHasChargeDates() {
    if (this.hasCharges) {
      if (this.currentOffenseRecord.charges
        .some((c: Charge) => c.offenseDate !== null || c.fileDate !== null || c.dispositionDate !== null)) {
          this.formControl.clearValidatorErrorByControlName('offenseRecord.hasRequiredDate', 'hasRequiredDate');
      } else {
        this.formControl.setValidationErrorByControlName('offenseRecord.hasRequiredDate', 'hasRequiredDate');
      }
    }
  }

  private get hasCharges(): boolean {
    return this.currentOffenseRecord !== null && this.currentOffenseRecord !== undefined
    && this.currentOffenseRecord.charges !== null && this.currentOffenseRecord.charges !== undefined
    && this.currentOffenseRecord.charges.length > 0;
  }

  private checkWorkOrderComplete() {
    this.canWorkOrderComplete = this.offense.offenseRecords.length > 0
    && this.offense.offenseRecords.every(or => or.referenceNumber !== null
      && or.referenceNumber !== undefined && or.referenceNumber.length > 0);
    this.changeDetectorRef.detectChanges();
  }

  private hasDobMismatch(dobInformation: any): boolean {

    let mismatch = false;
    if (dobInformation.fullDob || dobInformation.partialDob) {
      const year = this.offense.offenseSearch.dob.getFullYear();
      const month = this.offense.offenseSearch.dob.getMonth() + 1;
      const day = this.offense.offenseSearch.dob.getDate();

      let dobYear: number = null;
      let dobMonth: number = null;
      let dobDay: number = null;

      if (dobInformation.fullDob) {
        const dobDate = new Date(dobInformation.fullDob);
        dobYear = dobDate.getFullYear();
        dobMonth = dobDate.getMonth() + 1;
        dobDay = dobDate.getDate();
        mismatch = year !== dobYear || month !== dobMonth || day !== dobDay;
      } else {
        dobYear = +dobInformation.partialYear;
        dobMonth = +dobInformation.partialMonth;
        dobDay = +dobInformation.partialDay;
        mismatch = year !== dobYear || (month !== dobMonth && day !== dobDay);
      }
    }

    return mismatch;
  }

  private createOffenseObject(dobInformation: any): any {

    const offenseRecords = Array<any>();
    offenseRecords.push({
      requestNbr: this.currentOffenseRecord.requestNbr,
      offenseNbr: this.currentOffenseRecord.offenseNumber,
      isCourtCaseSentencing: this.formControl.getNumberByControlName('offenseRecord.sentenceLevel') === 0 ? 'o' : null,
      offenseDt: this.formControl.getShortDateByControlName('offenseRecord.offenseDate'),
      fileDt: this.formControl.getShortDateByControlName('offenseRecord.fileDate'),
      arrestDate: this.formControl.getShortDateByControlName('offenseRecord.arrestDate'),
      dispositionDt: this.formControl.getShortDateByControlName('offenseRecord.dispositionDate'),
      courtRecordedName: this.formControl.getValueByControlName('offenseRecord.courtRecordedFullName'),
      faxInfoInd: this.formControl.getCrimBooleanByControlName('offenseRecord.hasFaxInformation'),
      identifierDOB: this.formControl.getCrimBooleanByControlName('offenseRecord.hasDobIdentifier'),
      identifierSSN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasSsnIdentifier'),
      identifierName: this.formControl.getCrimBooleanByControlName('offenseRecord.hasNameIdentifier'),
      identifierAddress: this.formControl.getCrimBooleanByControlName('offenseRecord.hasAddressIdentifier'),
      identifierDLN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasDlnIdentifier'),
      identifierSIN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasSinIdentifier'),
      comments: this.formControl.getValueByControlName('offenseRecord.comments'),
      referenceNbr: this.formControl.getValueByControlName('offenseRecord.referenceNumber'),
      nameDiff: this.formControl.getCrimBooleanByControlName('offenseRecord.nameDiffers'),
      courtRecordDOB: dobInformation.fullDob,
      identifierPartialDOB: dobInformation.partialDob,
      partialMonth: dobInformation.partialMonth,
      partialDay: dobInformation.partialDay,
      partialYear: dobInformation.partialYear,
      identifierNoDOB: dobInformation.dobNotListed,
      nextCourtDate: this.formControl.getShortDateByControlName('offenseRecord.nextCourtDate'),
      probation: this.formControl.getValueByControlName('offenseRecord.probation'),
      jailTime: this.formControl.getValueByControlName('offenseRecord.jailTime'),
      prisonTime: this.formControl.getValueByControlName('offenseRecord.prisonTime'),
      suspensionTime: this.formControl.getValueByControlName('offenseRecord.suspensionTime'),
      fines: this.formControl.getValueByControlName('offenseRecord.fines'),
      courtCosts: this.formControl.getValueByControlName('offenseRecord.courtCosts'),
      otherSentenceNotes: this.formControl.getValueByControlName('offenseRecord.otherSentenceNotes'),
      charges: this.getCharges()
    });

    return offenseRecords;
  }

  private getCharges(): any[] {
    const charges = Array<any>();
    for (const charge of this.currentOffenseRecord.charges) {
      charges.push({
        requestNbr: charge.requestNbr,
        offenseNbr: charge.offenseNbr,
        countNbr: charge.countNbr,
        chargeLevel: charge.chargeLevel,
        charge: charge.charge,
        disposition: charge.disposition,
        chargeCd: charge.chargeCd,
        chargeDispDate: charge.chargeDispDate === null ? null : new Date(Date.UTC(charge.chargeDispDate.getFullYear(), charge.chargeDispDate.getMonth(), charge.chargeDispDate.getDate(), 0, 0, 0, 0)),
        chargeArrestDate: charge.chargeArrestDate === null ? null : new Date(Date.UTC(charge.chargeArrestDate.getFullYear(), charge.chargeArrestDate.getMonth(), charge.chargeArrestDate.getDate(), 0, 0, 0, 0)),
        chargeFileDate: charge.chargeFileDate === null ? null : new Date(Date.UTC(charge.chargeFileDate.getFullYear(), charge.chargeFileDate.getMonth(), charge.chargeFileDate.getDate(), 0, 0, 0, 0)),
        chargeOffenseDate: charge.chargeOffenseDate === null ? null : new Date(Date.UTC(charge.chargeOffenseDate.getFullYear(), charge.chargeOffenseDate.getMonth(), charge.chargeOffenseDate.getDate(), 0, 0, 0, 0)),
        noDispDateReason: charge.noDispDateReason,
        noArrestDateReason: charge.noArrestDateReason,
        noFileDateReason: charge.noFileDateReason,
        noOffenseDateReason: charge.noOffenseDateReason,
        chargeNextCourtDate: charge.chargeNextCourtDate === null ? null : new Date(Date.UTC(charge.chargeNextCourtDate.getFullYear(), charge.chargeNextCourtDate.getMonth(), charge.chargeNextCourtDate.getDate(), 0, 0, 0, 0)),
        chargeProbation: charge.chargeProbation,
        chargeJailTime: charge.chargeJailTime,
        chargePrisonTime: charge.chargePrisonTime,
        chargeSuspensionTime: charge.chargeSuspensionTime,
        chargeFines: charge.chargeFines,
        chargeCourtCosts: charge.chargeCourtCosts,
        chargeOtherSentenceNotes: charge.chargeOtherSentenceNotes,
        chargeStatute: charge.chargeStatute
      });
    }

    return charges;
  }

  private getDobInformation(): any {
    const dobType = this.formControl.getValueByControlName('offenseRecord.dobType');
    let month = this.formControl.getValueByControlName('offenseRecord.month');
    let day = this.formControl.getValueByControlName('offenseRecord.day');
    let year = this.formControl.getValueByControlName('offenseRecord.year');
    let fullDob = '';
    let partialDob = '';
    let dobNotListed = '';

    if ('full-dob' === dobType) {
      fullDob = `${month}/${day}/${year}`;
      month = null;
      day = null;
      year = null;
    } else if ('partial-dob' === dobType) {
      partialDob = 'o';
    } else {
      dobNotListed = 'o';
      month = null;
      day = null;
      year = null;
    }

    return {
      fullDob,
      partialDob,
      dobNotListed,
      partialMonth: month,
      partialDay: day,
      partialYear: year
    };
  }

  @ViewChild('offenseRecord') offenseRecordComponent;
  @ViewChild('offenseSearch') offenseSearchComponent;
  offense: Offense;
  requestNumber: number;
  offensePageForm: FormGroup;
  isSaving = false;
  canDelete = false;
  canWorkOrderComplete = false;
  isNewRecord = true;
  cacheControlKey: string;
  private currentOffenseRecord: OffenseRecord;
  private formControl: FormControl;
}



// WEBPACK FOOTER //
// ./src/app/offense/offense.component.ts